"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.companyQL = void 0;
var aws_appsync_1 = __importDefault(require("aws-appsync"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var _a = process === null || process === void 0 ? void 0 : process.env, REACT_APP_REGION = _a.REACT_APP_REGION, REACT_APP_COMPANYQL_URL = _a.REACT_APP_COMPANYQL_URL, REACT_APP_COMPANYQL_API_KEY = _a.REACT_APP_COMPANYQL_API_KEY;
// @ts-expect-error ts-migrate(2314) FIXME: Generic type 'AWSAppSyncClient<TCacheShape>' requi... Remove this comment to see the full error message
var CustomAppSyncClient = /** @class */ (function (_super) {
    __extends(CustomAppSyncClient, _super);
    function CustomAppSyncClient(options) {
        return _super.call(this, __assign(__assign({}, options), { disableOffline: true })) || this;
    }
    CustomAppSyncClient.prototype.query = function (options) {
        return _super.prototype.query.call(this, __assign(__assign({}, options), { fetchPolicy: 'no-cache', query: (0, graphql_tag_1["default"])(options.query) }));
    };
    CustomAppSyncClient.prototype.mutate = function (options) {
        return _super.prototype.mutate.call(this, __assign(__assign({}, options), { fetchPolicy: 'no-cache', mutation: (0, graphql_tag_1["default"])(options.mutation) }));
    };
    CustomAppSyncClient.prototype.subscribe = function (options) {
        return _super.prototype.subscribe.call(this, __assign(__assign({}, options), { fetchPolicy: 'no-cache', query: (0, graphql_tag_1["default"])(options.query) }));
    };
    return CustomAppSyncClient;
}(aws_appsync_1["default"]));
exports.companyQL = new CustomAppSyncClient({
    url: REACT_APP_COMPANYQL_URL,
    region: REACT_APP_REGION,
    auth: {
        type: 'API_KEY',
        apiKey: REACT_APP_COMPANYQL_API_KEY
    }
});
